import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div role="alert" className="flex min-h-[50vh] items-center justify-center">
            <div className="text-center">
              <h2 className="text-2xl font-bold text-[var(--text-primary)]">
                Something went wrong
              </h2>
              <p className="mt-2 text-[var(--text-body)]">
                Please refresh the page or try again later.
              </p>
              <button
                onClick={() => {
                  this.setState({ hasError: false });
                }}
                className="mt-4 rounded-[var(--radius)] bg-[var(--brand-500)] px-4 py-2 text-[var(--brand-text)] hover:bg-[var(--brand-600)]"
              >
                Try again
              </button>
            </div>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
